import React from "react";
import style from './Pages.module.css'
import Footer from "../components/layouts/footer/Footer";
import Announcement from "../components/layouts/announcement/AnnouncementBar";
import Header from "../components/layouts/header/Header";
import NewPassword from "../components/auth/forgetPassword/NewPassword";


const LoginPage = (props) => {
    return (<div className={style['container']}>
        <Announcement />
        <Header current={props.location.pathname} />
        <NewPassword />
        <Footer />
    </div>)
}
export default connect(LoginPage);